import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'sonner';
import '@/App.css';
import { AuthProvider } from '@/contexts/AuthContext';
import ProtectedRoute from '@/components/ProtectedRoute';
import Login from '@/pages/Login';
import SalesApplicationForm from '@/pages/SalesApplicationForm';
import ApplicationSuccess from '@/pages/ApplicationSuccess';

// NEW CLEAN SYSTEM
import Dashboard from '@/pages/DashboardNew';
import ApplicationsList from '@/pages/ApplicationsList';
import LiveItems from '@/pages/LiveItems';
import ItemDetail from '@/pages/ItemDetail';
import SellerProfileNew from '@/pages/SellerProfileNew';
import Tasks from '@/pages/Tasks';
import Buyers from '@/pages/Buyers';
import BuyerProfile from '@/pages/BuyerProfile';
import Calendar from '@/pages/Calendar';
import Messages from '@/pages/Messages';
import PayoutsPage from '@/pages/PayoutsPage';
import Settings from '@/pages/Settings';
import RecycleBin from '@/pages/RecycleBin';
import DataReentry from '@/pages/DataReentry';
import Nudges from '@/pages/Nudges';import SellerPortal from '@/pages/SellerPortal';
import Intel from '@/pages/Intel';

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            {/* Public Routes */}
            <Route path="/login" element={<Login />} />
            <Route path="/apply" element={<SalesApplicationForm />} />
            <Route path="/success" element={<ApplicationSuccess />} />
            <Route path="/portal/:token" element={<SellerPortal />} />
            
            {/* NEW CLEAN SYSTEM */}
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
            <Route path="/applications-list" element={<ProtectedRoute><ApplicationsList /></ProtectedRoute>} />
            <Route path="/applications" element={<Navigate to="/applications-list" replace />} />
            <Route path="/items" element={<ProtectedRoute><ApplicationsList /></ProtectedRoute>} />
            <Route path="/live-items" element={<ProtectedRoute><LiveItems /></ProtectedRoute>} />
            <Route path="/application/:appId" element={<ProtectedRoute><ItemDetail /></ProtectedRoute>} />
            <Route path="/item/:itemId" element={<ProtectedRoute><ItemDetail /></ProtectedRoute>} />
            <Route path="/seller/:sellerId" element={<ProtectedRoute><SellerProfileNew /></ProtectedRoute>} />
            <Route path="/calendar" element={<ProtectedRoute><Calendar /></ProtectedRoute>} />
            <Route path="/tasks" element={<ProtectedRoute><Tasks /></ProtectedRoute>} />
            <Route path="/buyers" element={<ProtectedRoute><Buyers /></ProtectedRoute>} />
            <Route path="/buyer/:buyerId" element={<ProtectedRoute><BuyerProfile /></ProtectedRoute>} />
            <Route path="/messages" element={<ProtectedRoute><Messages /></ProtectedRoute>} />
            <Route path="/payouts" element={<ProtectedRoute><PayoutsPage /></ProtectedRoute>} />
            <Route path="/settings" element={<ProtectedRoute><Settings /></ProtectedRoute>} />
            <Route path="/recycle-bin" element={<ProtectedRoute><RecycleBin /></ProtectedRoute>} />
            <Route path="/data-reentry" element={<ProtectedRoute><DataReentry /></ProtectedRoute>} />
            <Route path="/nudges" element={<ProtectedRoute><Nudges /></ProtectedRoute>} />
            <Route path="/intel" element={<ProtectedRoute><Intel /></ProtectedRoute>} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;